import { useState } from 'react'

import { UnifiedPerson } from 'CitizenProfile/types'
import getUnifiedPersonOnCustomForm from './services/getUnifiedPersonOnCustomForm'

export default function useGetUnifiedPersonByID() {
  const [loadingUnifiedPerson, setLoadingUnifiedPerson] = useState<boolean>(false)
  const [unifiedPerson, setUnifiedPerson] = useState<UnifiedPerson>({})

  async function getUnifiedPerson(unifiedPersonId?: string) {
    setLoadingUnifiedPerson(true)
    const response = await getUnifiedPersonOnCustomForm({ unifiedPersonId: unifiedPersonId as string })
    let unifiedPersonFromAPI: UnifiedPerson = {}
    if (response?.header?.success) {
      unifiedPersonFromAPI = response?.body?.unified_person
      setUnifiedPerson(unifiedPersonFromAPI)
    }
    setLoadingUnifiedPerson(false)
    return unifiedPersonFromAPI
  }

  return { getUnifiedPerson, unifiedPerson, loadingUnifiedPerson }
}
